import React from 'react';
import { Anchor, Box, Button, Group, PasswordInput, Stack, Text } from '@mantine/core';
import FlowAlert from '@/components/auth/flow/components/parts/Flow.Alert';
import FlowAlternatives from '@/components/auth/flow/components/parts/Flow.Alternatives';
import { BEAUTH_PASSWORD_MAX } from '@/config/beauth.config';
import type { TypeFlowScreenProps } from '@/types/auth/types.auth.flow';

type Props = TypeFlowScreenProps & { step: string; passkeySupported: boolean; onForgot?: () => void };

const FlowPassword: React.FC<Props> = ({ flow, message, step, passkeySupported, onForgot }) => {
    const [password, setPassword] = React.useState('');
    const [local, setLocal] = React.useState<string | null>(null);
    const fieldError = local ?? (message?.field === 'password' ? message.text : null);

    React.useEffect(() => {
        if (message?.field === 'password') setPassword('');
    }, [message]);

    const submit = (event: React.FormEvent) => {
        event.preventDefault();
        if (flow.busy) return;
        if (!password) {
            setLocal('La password è obbligatoria');
            return;
        }
        void flow.submit(step, { password });
    };

    return (
        <form onSubmit={submit} noValidate>
            <Stack gap="15px">
                <FlowAlert message={message} field="password" />
                {flow.hint ? <input type="email" name="username" autoComplete="username" hidden readOnly value={flow.hint} /> : null}
                <Box>
                    <PasswordInput
                        withAsterisk
                        label="Password"
                        placeholder="La tua password"
                        autoComplete="current-password"
                        maxLength={BEAUTH_PASSWORD_MAX}
                        data-autofocus
                        value={password}
                        error={fieldError ?? undefined}
                        onChange={(event) => {
                            setLocal(null);
                            setPassword(event.currentTarget.value.slice(0, BEAUTH_PASSWORD_MAX));
                        }}
                    />
                    {onForgot ? (
                        <Group justify="left" gap={5} mt={5}>
                            <Text size="sm" c="dimmed">Password dimenticata?</Text>
                            <Anchor component="button" type="button" size="sm" onClick={onForgot}>RECUPERA</Anchor>
                        </Group>
                    ) : null}
                </Box>
                <Button type="submit" radius="md" loading={flow.busy} disabled={flow.busy}>ACCEDI</Button>
                <FlowAlternatives flow={flow} current="password" passkeySupported={passkeySupported} />
            </Stack>
        </form>
    );
};

export default FlowPassword;
